module.exports = __webpack_public_path__ + "img/radio-wai-iban.880f36cb.jpg";